const ChipMap = {
    Flow: {
        id: 200126,
        name: 'Flow',
        type: 'struct',
        title: '颁奖流程',
        groupName: '盛典现场',
    },
    Talk: {
        id: 225674,
        name: 'Talk',
        type: 'recommend',
        title: '巅峰对话',
        groupName: '巅峰对话',
    },
    Live: {
        id: 225675,
        name: 'Live',
        type: 'recommend',
        title: '直播',
        groupName: '盛典现场',
    },
    News: {
        id: 225676,
        name: 'News',
        type: 'recommend',
        title: '新闻动态',
        groupName: '盛典现场',
    },
    Pics: {
        id: 225677,
        name: 'Pics',
        type: 'recommend',
        title: '图集',
        groupName: '盛典现场',
    },
    Stars: {
        id: 225678,
        name: 'Stars',
        type: 'recommend',
        title: '明星助力',
        groupName: '盛典现场',
    },
    Alerter: {
        id: 170167,
        name: 'Alerter',
        type: 'struct',
        title: '弹窗控制',
        groupName: '弹窗控制',
    },
};

module.exports = { ChipMap };
